import { render, staticRenderFns } from "./ConsumptionLineDetail.vue?vue&type=template&id=2b148a8f&scoped=true&"
import script from "./ConsumptionLineDetail.vue?vue&type=script&lang=js&"
export * from "./ConsumptionLineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b148a8f",
  null
  
)

export default component.exports